export default __webpack_public_path__ + "static/media/fridge1-after1-768w.a0290b7c.png";